import { createContext, useContext } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const [name, setName] = useLocalStorage('red_profile_name', '');
  const [country, setCountry] = useLocalStorage('red_profile_country', '');
  const [onboardingComplete, setOnboardingComplete] = useLocalStorage('red_onboarding_complete', false);
  const [tutorialSeen, setTutorialSeen] = useLocalStorage('red_tutorial_seen', false);
  // Erstkontakt: „Verbinde deine erste Quelle"-Stufe einmalig gesehen/übersprungen.
  const [firstSourceSeen, setFirstSourceSeen] = useLocalStorage('red_first_source_seen', false);
  const [language, setLanguage] = useLocalStorage('red_lang', 'de');

  const initials = name.trim()
    ? name.trim().split(/\s+/).map(w => w[0].toUpperCase()).slice(0, 2).join('')
    : '?';

  return (
    <ProfileContext.Provider
      value={{
        name, setName, initials,
        country, setCountry,
        onboardingComplete, setOnboardingComplete,
        tutorialSeen, setTutorialSeen,
        firstSourceSeen, setFirstSourceSeen,
        language, setLanguage,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  return useContext(ProfileContext);
}
